import React from 'react';
import moment from "moment";
import {PAGINATION} from "ubs-framework/v2/common/constant";
import {REMINDER} from "../../common/constant";

export const startDate = new Date(moment().subtract(6, 'days').set({'hour': 0, 'minute': 0, 'second': 0}));
export const endDate = new Date(moment().set({'hour': 0, 'minute': 0, 'second': 0}));

const initialState = {
    socketId: '',
    _id: '',
    reminderList: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        location: null,
        to: null,
        date: null,
        status: REMINDER.STATUS[0],
    },
    showReminder: null
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'AUTHENTICATE': {
            return {
                ...state,
                reminderList: {
                    ...state.reminderList,
                    to: {
                        label: `${action.payload.firstName} ${action.payload.lastName}`,
                        name: `${action.payload.firstName} ${action.payload.lastName}`,
                        profileImage: action?.payload?.profileImage,
                        value: action.payload._id,
                        _id: action.payload._id,
                    }
                }
            };
        }
        case 'FILTER_REMINDER_LIST': {
            return {...state, reminderList: {...state.reminderList, currentPage: PAGINATION?.CURRENT_PAGE, ...action.payload}}
        }
        case 'SHOW_REMINDER': {
            return {...state, showReminder: action.payload}
        }

        default: {
            return state;
        }
    }
}
